import { render, staticRenderFns } from "./IconSettingsProfile.vue?vue&type=template&id=c13dc9a0&"
import script from "./IconSettingsProfile.vue?vue&type=script&lang=js&"
export * from "./IconSettingsProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c13dc9a0')) {
      api.createRecord('c13dc9a0', component.options)
    } else {
      api.reload('c13dc9a0', component.options)
    }
    module.hot.accept("./IconSettingsProfile.vue?vue&type=template&id=c13dc9a0&", function () {
      api.rerender('c13dc9a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSettingsProfile.vue"
export default component.exports